import { hsmBackendClient } from './client';
import { AddOnPurchase, IControllerResponse } from './types';

export interface PostAddOnPurchaseInput {
  messageQty: number;
}

/**
 * Buys an add-on (extra package) for the given company. Hits
 * `POST /company/{companyId}/add-on-purchase` and returns the new
 * `AddOnPurchase`. Add-ons stack on top of the plan and are consumed
 * after the plan's quota for the period runs out.
 */
export async function postAddOnPurchase(
  companyId: string,
  input: PostAddOnPurchaseInput
): Promise<AddOnPurchase> {
  const response = await hsmBackendClient.post<
    IControllerResponse<AddOnPurchase>
  >(`/company/${encodeURIComponent(companyId)}/add-on-purchase`, input);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
